import React from 'react';
import TableAllCustomerCampaigns from "./TableAllCustomerCampaigns";
import TableAllCustomersVectors from "./TableAllCustomersVectors";
import {Col, Row} from "reactstrap";
import TileComingSoon from "../../../../../components/customBreachBits/metrics/TileComingSoon";
import TileAdminExternalOKRBreachesTotal
    from "../../../../../components/customBreachBits/admin/AdminDashInfo/TileAdminExternalOKRBreachesTotal";


const AdminExternalPage = (props) => {


    return(
        <div className="app-wrapper h-100">

            <Row>
                <Col>
                    <TileComingSoon subtitle={"New Threats Detected"}/>
                </Col>
                <Col>
                    <TileComingSoon subtitle={"New Threat Tools Deployed"}/>
                </Col>
                <Col >
                    {/*<TileComingSoon subtitle={"Recent Perimeter Breaches"}/>*/}
                    <TileAdminExternalOKRBreachesTotal/>
                </Col>
                <Col>
                    <TileComingSoon subtitle={"Recent Phishing Nibbles"}/>
                </Col>
                <Col >
                    <TileComingSoon subtitle={"Recent Phishing Breaches"}/>
                </Col>

            </Row>

            <Row style={{display: 'flex', alignItems:`center`, }}>
                <Col xl={"12"}>
                    <TableAllCustomerCampaigns title={"Active Campaigns for All Customers"}/>
                </Col>
            </Row>

            <Row style={{display: 'flex', alignItems:`center`, }}>
                <Col xl={"12"}>
                    <TableAllCustomersVectors/>
                </Col>
            </Row>


            <Row style={{display: 'flex', alignItems:`center`, }}>
                <Col xl={"12"}>
                    <TableAllCustomerCampaigns  verbose={true} title={"All Campaigns for All Customers"}/>
                </Col>
            </Row>


        </div>
    )
}

export default AdminExternalPage;